import Network from "./network";
import Specie from "./specie";
import NeatParameters from "./parameters";
import InnovationDB from "./innovatinoDB";

function speciate(pool: Network[], params: NeatParameters): Specie[] {
  const species = [new Specie(pool[0])];

  for (let i = 1; i < pool.length; i++) {
    let added = false;

    for (const specie of species) {
      if (specie.tryAdding(pool[i], params)) {
        added = true;
        break;
      }
    }

    if (!added) {
      species.push(new Specie(pool[i]));
    }
  }

  return species;
}

export function evolve(
  pool: Network[],
  params: NeatParameters,
  innovDB: InnovationDB
): [Network[], Specie[]] {
  innovDB.clearDB();

  pool.sort((a, b) => b.getFitness() - a.getFitness());

  const species = speciate(pool, params);

  const fitnessList = [];
  const newPool = [];

  for (const specie of species) {
    specie.killWorst(params.speciation.survivalRate);
    fitnessList.push(specie.getFitnessSum());

    newPool.push(...specie.getElites(params.speciation.elitism));
  }

  let fitnessSum = fitnessList.reduce((a, b) => a + b);
  const elites = newPool.length;

  if (fitnessSum === 0) {
    for (let i = 0; i < fitnessList.length; i++) {
      fitnessList[i] = 1;
      fitnessSum++;
    }
  }


  for (let i = 0; i < fitnessList.length; i++) {
    for (
      let j = 0;
      j < (pool.length - elites) * (fitnessList[i] / fitnessSum);
      j++
    ) {
      const child = species[i].mate();
      if (Math.random() < params.mutation.rate) child.mutate(params);
      newPool.push(child);
    }
  }

  return [newPool, species];
}
